import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const CommonSearch2 = ({ value, setValue, data }) => {
  const customFilter = (option, { inputValue }) => {
    const lowerInput = inputValue.toLowerCase();
    return option?.d_name && option?.d_name.toLowerCase().includes(lowerInput);
  };
  return (
    <div>
      {data?.length && (
        <Autocomplete
          disablePortal
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          id="combo-box-demo"
          options={data}
          getOptionLabel={(option) =>
            `${option?.d_name} - ${option?.d_address}`
          }
          sx={{ width: 300 }}
          filterOptions={(options, { inputValue }) => {
            return options?.filter((option) =>
              customFilter(option, { inputValue })
            );
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      )}
    </div>
  );
};

export default CommonSearch2;
